var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect, _rect2, _path22, _path23, _path24, _path25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotices = function SvgNotices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4031_94846)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 90C69.8528 90 90 69.8528 90 45C90 20.1472 69.8528 0 45 0C20.1472 0 0 20.1472 0 45C0 69.8528 20.1472 90 45 90Z",
    fill: "#D6EDDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2688 25.1651C60.9558 25.1651 60.6427 25.0574 60.3861 24.8392L44.8892 11.5467L30.2006 24.6622C29.6412 25.1626 28.7815 25.1138 28.2837 24.5544C27.7833 23.995 27.8321 23.1353 28.3915 22.6375L43.9679 8.7316C44.476 8.27739 45.2407 8.27226 45.7565 8.71364L62.1567 22.7786C62.7264 23.2662 62.7906 24.1233 62.303 24.693C62.0335 25.0061 61.6538 25.1677 61.2714 25.1677L61.2688 25.1651Z",
    fill: "#4DA061"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4492 22.3906H11.2207C9.66174 22.3906 8.39795 23.6544 8.39795 25.2134V71.0189C8.39795 72.5779 9.66174 73.8417 11.2207 73.8417H79.4492C81.0082 73.8417 82.2719 72.5779 82.2719 71.0189V25.2134C82.2719 23.6544 81.0082 22.3906 79.4492 22.3906Z",
    fill: "#4DA061"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.33 25.2148H11.2212V70.9148H79.33V25.2148Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0633 39.2704L18.0273 39.918L18.6353 50.2792L29.6713 49.6316L29.0633 39.2704Z",
    fill: "#D0EAF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6922 36.6052L17.8022 38.5078L19.7048 49.3978L30.5948 47.4952L28.6922 36.6052Z",
    fill: "#25BEEF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6519 36.4768L38.7212 34.8242L37.0686 45.7549L47.9993 47.4075L49.6519 36.4768Z",
    fill: "#D0EAF9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5851 55.2098L30.772 52.9102L28.4723 63.7232L39.2854 66.0229L41.5851 55.2098Z",
    fill: "#D0EAF9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6788 35.9305L38.9736 33.1719L36.215 43.8771L46.9203 46.6357L49.6788 35.9305Z",
    fill: "#FDBC3B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8555 54.4696L31.5698 50.418L27.5182 60.7037L37.8039 64.7553L41.8555 54.4696Z",
    fill: "#E2383E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9438 38.6972C22.2535 38.6972 21.689 38.1352 21.689 37.4423C21.689 36.7495 22.2509 36.1875 22.9438 36.1875C23.6367 36.1875 24.1987 36.7495 24.1987 37.4423C24.1987 38.1352 23.6367 38.6972 22.9438 38.6972Z",
    fill: "#FFC513"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3764 35.6152C43.6861 35.6152 43.1216 35.0532 43.1216 34.3603C43.1216 33.6675 43.6836 33.1055 44.3764 33.1055C45.0693 33.1055 45.6313 33.6675 45.6313 34.3603C45.6313 35.0532 45.0693 35.6152 44.3764 35.6152Z",
    fill: "#6C97CF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6855 53.7714C35.9952 53.7714 35.4307 53.2094 35.4307 52.5166C35.4307 51.8237 35.9927 51.2617 36.6855 51.2617C37.3784 51.2617 37.9403 51.8237 37.9403 52.5166C37.9403 53.2094 37.3784 53.7714 36.6855 53.7714Z",
    fill: "#6C97CF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5854 33.1973L73.8355 33.2992C74.418 33.3025 74.8875 33.7773 74.8843 34.3598L74.7423 59.7821C74.7391 60.3646 74.2643 60.8341 73.6818 60.8309L55.4317 60.729C54.8492 60.7257 54.3796 60.2509 54.3829 59.6684L54.5249 34.2461C54.5281 33.6636 55.0029 33.194 55.5854 33.1973Z",
    fill: "#A9DACA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2632 34.7284L56.1396 34.6328L56.0019 59.293L73.1255 59.3887L73.2632 34.7284Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3461 38.9122L69.7824 38.9705C69.9851 38.9716 70.151 39.1394 70.1499 39.3421L70.1496 39.396C70.1484 39.6013 69.9807 39.7646 69.778 39.7634L59.3417 39.7051C59.1389 39.704 58.9731 39.5363 58.9742 39.3336L58.9745 39.2797C58.9756 39.077 59.1434 38.9111 59.3461 38.9122Z",
    fill: "#D6EDDE",
    stroke: "#D6EDDE",
    strokeWidth: 0.726217,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7844 42.8064L59.348 42.7482C59.144 42.747 58.9776 42.9115 58.9765 43.1156L58.9762 43.1695C58.975 43.3736 59.1395 43.5399 59.3436 43.5411L69.7799 43.5994C69.984 43.6005 70.1504 43.436 70.1515 43.2319L70.1518 43.178C70.153 42.9739 69.9884 42.8076 69.7844 42.8064Z",
    fill: "#D6EDDE",
    stroke: "#D6EDDE",
    strokeWidth: 0.726217,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3471 46.5841L69.7834 46.6424C69.9861 46.6435 70.152 46.8112 70.1508 47.014L70.1505 47.0679C70.1494 47.2731 69.9817 47.4364 69.779 47.4353L59.3426 47.377C59.1399 47.3759 58.974 47.2082 58.9752 47.0054L58.9755 46.9516C58.9766 46.7488 59.1443 46.583 59.3471 46.5841Z",
    fill: "#D6EDDE",
    stroke: "#D6EDDE",
    strokeWidth: 0.726217,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3461 50.42L69.7824 50.4783C69.9851 50.4795 70.151 50.6472 70.1499 50.8499L70.1496 50.9038C70.1484 51.1091 69.9807 51.2724 69.778 51.2712L59.3417 51.213C59.1389 51.2118 58.9731 51.0441 58.9742 50.8414L58.9745 50.7875C58.9756 50.5848 59.1434 50.4189 59.3461 50.42Z",
    fill: "#D6EDDE",
    stroke: "#D6EDDE",
    strokeWidth: 0.726217,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7844 54.3143L59.348 54.256C59.144 54.2548 58.9776 54.4193 58.9765 54.6234L58.9762 54.6773C58.975 54.8814 59.1395 55.0478 59.3436 55.0489L69.7799 55.1072C69.984 55.1083 70.1504 54.9438 70.1515 54.7397L70.1518 54.6858C70.153 54.4818 69.9884 54.3154 69.7844 54.3143Z",
    fill: "#D6EDDE",
    stroke: "#D6EDDE",
    strokeWidth: 0.726217,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0101 32.0087L67.4015 32.0389C68.2663 32.0437 68.9629 32.7481 68.9581 33.6129L68.952 34.7061L60.43 34.6585L60.4361 33.5653C60.4409 32.7005 61.1454 32.0039 62.0101 32.0087Z",
    fill: "#FDBC3B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5786,
    y: 25.1758,
    width: 45.8456,
    height: 1.31524,
    transform: "rotate(90 12.5786 25.1758)",
    fill: "#D0EAF9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79.2798,
    y: 26.4922,
    width: 67.2652,
    height: 1.31524,
    transform: "rotate(-180 79.2798 26.4922)",
    fill: "#D0EAF9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1688 71.0234L9.38379 72.7145",
    stroke: "#4DA061",
    strokeWidth: 0.751567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1688 25.1758L9.38379 23.4848",
    stroke: "#4DA061",
    strokeWidth: 0.751567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4675 71.0234L81.2524 72.7145",
    stroke: "#4DA061",
    strokeWidth: 0.751567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4675 25.1758L81.2524 23.4848",
    stroke: "#4DA061",
    strokeWidth: 0.751567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4031_94846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
};
export default SvgNotices;